import React, { useMemo } from 'react';

import { BuildStatusCard } from 'src/components/build-status-card';
import { BuildStatusProvider } from 'src/components/build-status-card/services/build-status-service/build-status-service';
import urls from 'src/redux/pull-request/urls';
import baseUrls from 'src/urls/source';

export function PrBuildStatusCard({
  repositoryOwner,
  repositorySlug,
  pullRequestId,
}: {
  repositoryOwner: string;
  repositorySlug: string;
  pullRequestId: number;
}): JSX.Element {
  const repoFullSlug = `${repositoryOwner}/${repositorySlug}`;

  const buildStatusURL = useMemo(
    () =>
      urls.api.v20.statusesFetch(
        repositoryOwner,
        repositorySlug,
        pullRequestId
      ),
    [repositoryOwner, repositorySlug, pullRequestId]
  );

  const repoMetadataURL = useMemo(
    () => baseUrls.api.internal.repositoryMetadataURL(repoFullSlug),
    [repoFullSlug]
  );

  return (
    <BuildStatusProvider
      buildStatusURL={buildStatusURL}
      repositoryMetadataURL={repoMetadataURL}
      repositoryFullSlug={repoFullSlug}
    >
      <BuildStatusCard />
    </BuildStatusProvider>
  );
}
